import { Controller } from '@hotwired/stimulus';

const CLOSE_MS = 260;

/** Sheet News: community tip modal */
export default class extends Controller {
  static targets = ['communityDialog', 'communityTrigger', 'communityField', 'communitySubmit'];

  connect() {
    this.onDialogCancel = this.onDialogCancel.bind(this);
    this.communityDialogTarget.addEventListener('cancel', this.onDialogCancel);
    this.updateCommunityProgress();

    if (window.location.hash === '#community') {
      this.openCommunity({ preventDefault() {}, currentTarget: this.communityTriggerTarget });
    }
  }

  disconnect() {
    this.communityDialogTarget.removeEventListener('cancel', this.onDialogCancel);
  }

  openCommunity(event) {
    event?.preventDefault();
    const dialog = this.communityDialogTarget;
    if (dialog.open) return;

    dialog.showModal();
    this.setDialogOrigin(event?.currentTarget);
    dialog.classList.remove('bs-sheet-news__dialog--closing', 'bs-sheet-news__dialog--visible');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        dialog.classList.add('bs-sheet-news__dialog--visible');
      });
    });

    this.updateCommunityProgress();
  }

  updateCommunityProgress() {
    if (!this.hasCommunitySubmitTarget) return;

    const filled = this.communityFieldTargets.filter((field) => this.communityFieldFilled(field)).length;
    const percent = filled * 25;
    const submit = this.communitySubmitTarget;
    const complete = percent === 100;

    submit.style.setProperty('--submit-progress', `${percent}%`);
    submit.disabled = !complete;
    submit.classList.toggle('bs-sheet-news__btn--progress-complete', complete);
    submit.classList.toggle('bs-sheet-news__btn--progress-mid', percent >= 50);
  }

  communityFieldFilled(field) {
    const value = field.value.trim();
    if (!value) return false;

    if (field.type === 'email') {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    if (field.type === 'url') {
      try {
        const url = new URL(value.includes('://') ? value : `https://${value}`);
        return url.hostname.includes('.');
      } catch {
        return false;
      }
    }

    return true;
  }

  closeCommunity(event) {
    event?.preventDefault();
    this.animateClose();
  }

  backdropClose(event) {
    if (event.target === this.communityDialogTarget) {
      this.animateClose();
    }
  }

  onDialogCancel(event) {
    event.preventDefault();
    this.animateClose();
  }

  animateClose() {
    const dialog = this.communityDialogTarget;
    if (!dialog.open || dialog.classList.contains('bs-sheet-news__dialog--closing')) return;

    dialog.classList.remove('bs-sheet-news__dialog--visible');
    dialog.classList.add('bs-sheet-news__dialog--closing');

    window.setTimeout(() => {
      if (!dialog.classList.contains('bs-sheet-news__dialog--closing')) return;
      dialog.classList.remove('bs-sheet-news__dialog--closing');
      dialog.close();
    }, CLOSE_MS);
  }

  setDialogOrigin(trigger) {
    const dialog = this.communityDialogTarget;

    if (!trigger || !(trigger instanceof HTMLElement)) {
      dialog.style.setProperty('--dialog-origin-x', '72%');
      dialog.style.setProperty('--dialog-origin-y', '92%');
      return;
    }

    const triggerRect = trigger.getBoundingClientRect();
    const dialogRect = dialog.getBoundingClientRect();
    const x = triggerRect.left + triggerRect.width / 2 - dialogRect.left;
    const y = triggerRect.top + triggerRect.height / 2 - dialogRect.top;

    dialog.style.setProperty('--dialog-origin-x', `${x}px`);
    dialog.style.setProperty('--dialog-origin-y', `${y}px`);
  }
}
